module.exports = __webpack_public_path__ + "img/croatia.6770504a.svg";